import IcAspectRatio from './IcAspectRatio'

export default IcAspectRatio
